import { render, staticRenderFns } from "./ZipCodeTextArea.vue?vue&type=template&id=070627b0&"
import script from "./ZipCodeTextArea.vue?vue&type=script&lang=js&"
export * from "./ZipCodeTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports